import { SelectOption, yup } from 'form';

import { extractStringBetweenParentheses } from '../extractStringBetweenParentheses/extractStringBetweenParentheses';

export const matchInspectorToCompany = (
  inspectorOptions: SelectOption[],
  companyOptions: SelectOption[]
): yup.TestFunction<yup.Maybe<number | null | undefined>, yup.AnyObject> => {
  return (value, context) => {
    const { inspection_company } = context.parent;

    const isInspectorSpecified = Boolean(value);
    const isCompanySpecified = Boolean(inspection_company);

    if (!isInspectorSpecified || !isCompanySpecified) {
      return true;
    }

    const inspectorOption = inspectorOptions.find((inspector) => inspector.value === value);

    if (!inspectorOption) {
      return true;
    }

    const inspectorCompanyName = extractStringBetweenParentheses(inspectorOption.label);

    if (!inspectorCompanyName) {
      return true;
    }

    const company = companyOptions.find((company) => company.label === inspectorCompanyName);

    return company?.value === inspection_company;
  };
};
